import type { ResponsesGridRow } from "./types";

/**
 * Reorders `rows` to match the order in `orderedIds`, falling back to
 * `rows`'s natural order for anything not mentioned. Rows in
 * `orderedIds` that no longer exist are skipped; rows added since the
 * order was saved are appended in their incoming order.
 *
 * Pure / non-mutating so it is safe inside `useMemo`.
 */
export const applyRowOrder = (
  rows: ResponsesGridRow[],
  orderedIds: readonly string[] | undefined,
): ResponsesGridRow[] => {
  if (!orderedIds || orderedIds.length === 0 || rows.length === 0) {
    return rows;
  }

  const byId = new Map<string, ResponsesGridRow>();
  rows.forEach((row) => byId.set(row.carrierId, row));

  const seen = new Set<string>();
  const ordered: ResponsesGridRow[] = [];

  orderedIds.forEach((id) => {
    const row = byId.get(id);
    if (row) {
      ordered.push(row);
      seen.add(id);
    }
  });

  rows.forEach((row) => {
    if (!seen.has(row.carrierId)) {
      ordered.push(row);
    }
  });

  return ordered;
};
